module.exports = __webpack_public_path__ + "img/555.1d2e5f08.jpg";